module.exports = __webpack_public_path__ + "static/icons/icon-resort-guide--white-23068cebd4c399d4fe6ffac29a43f07c.svg";